import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (radioTitle) are preserved — the factory returns them closed over the
// theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.overlay,
      justifyContent: 'flex-end',
    },
    safeareaContainer: {
      backgroundColor: colors.surfaceElevated,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
    },
    bottomContainer: {
      padding: 24,
    },
    title: {
      fontFamily: FONTS.boldFont,
      fontSize: 18,
      color: colors.textPrimary,
    },
    subtitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      color: colors.textMuted,
      marginTop: 8,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 32,
    },
    button: {
      flex: 1,
    },
    marginTop16: {
      marginTop: 16,
    },
    paddingVertical16: {
      paddingVertical: 16,
    },
    checkboxStyle: {
      height: 24,
      width: 24,
    },
    radioTitle: selected => ({
      fontSize: 18,
      fontFamily: selected ? FONTS.semiboldFont : FONTS.regularFont,
    }),
  });

export default makeStyles;
